import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { BoundingBox } from '../features/map/mapSlice';
import { buildTrafficIncidentsUrl, mapTrafficIncidents, type TrafficIncident } from './fetchTrafficIncidents';

type FetchTrafficIncidentsQuery = {
    apiKey: string;
    boundingBox: BoundingBox;
    language?: string;
};

export const FETCH_TRAFFIC_INCIDENTS_TAG = 'FETCH_TRAFFIC_INCIDENTS_TAG';

export const trafficApi = createApi({
    reducerPath: 'trafficApi',
    baseQuery: fetchBaseQuery({ baseUrl: '' }),
    tagTypes: [FETCH_TRAFFIC_INCIDENTS_TAG],
    endpoints: builder => ({
        fetchTrafficIncidents: builder.query<TrafficIncident[], FetchTrafficIncidentsQuery>({
            query: ({ apiKey, boundingBox, language }) => buildTrafficIncidentsUrl(boundingBox, apiKey, language),
            transformResponse: mapTrafficIncidents,
            providesTags: [FETCH_TRAFFIC_INCIDENTS_TAG],
        }),
    }),
});

export const { useFetchTrafficIncidentsQuery } = trafficApi;
